import module from 'guest/module.js'
import template from './template.html'

const langs = {
  es_MX: 'ESPAÑOL',
  en_US: 'ENGLISH',
}

class GuestIdiomaComponent {
  constructor ($translate, $http, $session, $scope, $q, GuestIdioma) {
    this.$translate = $translate
    this.$http = $http
    this.$session = $session
    this.$scope = $scope
    this.$q = $q
    this.GuestIdioma = GuestIdioma
    this.onChange = null
    this.lang = $translate.proposedLanguage() || $translate.use()
    this.langs = langs
  }

  $onInit () {
    this.$scope.$on('$sessionAuth', () => (this.$session.data().then((user) => (this.lang = user.lang))))
  }

  toggle () {
    let promise

    this.lang = this.lang === 'es_MX' ? 'en_US' : 'es_MX'

    this.$translate.use(this.lang)

    if (this.$session.isAuth() && this.$session.dataTemporal.lang !== this.lang) {
      promise = this.GuestIdioma.post({lang: this.lang})
        .then((response) => {
          this.$session.dataTemporal.lang = response.data

          return lang
        })
    } else {
      promise = this.$q.when(this.lang)
    }

    return promise.then((lang) => (this.onChange({lang: lang})))
  }
}

module.component('guestIdioma', {
  controller: GuestIdiomaComponent,
  template,
  bindings: {
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/guest/components/idioma/component.js